// extracted by mini-css-extract-plugin
export var alt = "RoomCard-module--alt--be5cf";
export var btn = "RoomCard-module--btn--b1cbc";
export var container = "RoomCard-module--container--58b53";
export var desktopOnly = "RoomCard-module--desktopOnly--3da26";
export var main = "RoomCard-module--main--2380b";
export var mobileOnly = "RoomCard-module--mobileOnly--2d93a";
export var promoBadge = "RoomCard-module--promoBadge--6831d";
export var styledModal = "RoomCard-module--styledModal--55e27";
export var styledRoomCard = "RoomCard-module--styledRoomCard--fc6d2";
export var textLeft = "RoomCard-module--textLeft--c40ca";
export var unlockPriceCta = "RoomCard-module--unlockPriceCta--01456";
export var urgencyBadge = "RoomCard-module--urgencyBadge--74ba3";
export var visuallyHidden = "RoomCard-module--visuallyHidden--a02c2";